<!--
================================================
Un composant affichant une section contenant les tarifs de l'application
⚠️ Ce composant a été copié depuis le site nuxt et adapté pour la pwa
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->
<template>
  <div class="faqSection " v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <img
        class=" is-block m-auto "
        src="../../assets/img/illustrations/Questions-amico.svg"
        alt="illustration"
        height="140px"
        width="140px" />

      <div class="contTitle" lazy-background="~/assets/img/pricing/icons-illustration-lightgreen.png"> <!--@todo gérer l'image manquante -->
        <h2>{{$t('questionsFréquentes')}}</h2>
      </div>

      <div class="columns is-centered">
        <div class="column is-10">
          <div class="columns contQuestions">
            <div class="column a">

              <!-- À quoi sert Cronocloud ?-->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'question']" class="icon"/>
                </div>
                <h5>{{faqContent[0].q}}</h5>
                <p>{{faqContent[0].a}}</p>
              </div>

              <!-- Comment les paiements sont-ils sécurisés ?-->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'lock']" class="icon"/>
                </div>
                <h5>{{faqContent[4].q}}</h5>
                <p v-html="faqContent[4].a"
                ></p>
              </div>


              <!-- Puis-je changer de plan plus tard ? -->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'toggle-on']" class="icon"/>
                </div>
                <h5>{{faqContent[2].q}}</h5>
                <p>{{faqContent[2].a}}</p>
              </div>

              <!-- Peut-on facilement annuler un abonnement ?-->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'ban']" class="icon"/>
                </div>
                <h5>{{faqContent[5].q}}</h5>
                <p>{{faqContent[5].a}}</p>
              </div>
            </div>

            <div class="column is-1"></div>
            <div class="column b">

              <!-- Puis-je utiliser Cronocloud sur mon mobile ? -->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'mobile-alt']" class="icon"/>
                </div>
                <h5>{{faqContent[1].q}}</h5>
                <p>{{faqContent[1].a}}</p>
              </div>

              <!-- Quels sont les moyens de paiement accepté ? -->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'credit-card']" class="icon"/>
                </div>
                <h5>{{faqContent[3].q}}</h5>
                <p>{{faqContent[3].a}}</p>
              </div>


              <!-- Proposez-vous des réductions ?-->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'percentage']" class="icon"/>
                </div>
                <h5>{{faqContent[7].q}}</h5>
                <p>{{faqContent[7].a}}</p>
              </div>

              <!-- Qu'est-ce que le "1% pour le climat"? -->
              <div class="question">
                <div class="picto">
                  <font-awesome-icon :icon="['fas', 'tree']" class="icon"/>
                </div>
                <h5>{{faqContent[6].q}}</h5>
                <p>{{faqContent[6].a}}
                  <a target="_blank"  href="https://climate.stripe.com/VPuh1q"> {{$t('enSavoirPlus')}}</a>
                </p>

              </div>


            </div>
          </div>

          <div class="invitContact">

            <div class="picto">
              <font-awesome-icon :icon="['far', 'comment']" class="icon com"/>
              <font-awesome-icon :icon="['far', 'smile-wink']" class="icon smile"/>
            </div>

            <div class="txt">
              <h6>{{$t('vousAvezEncoreDesQuestions')}}</h6>

              <p>
                <a v-bind:href="supportEmail">{{$t('contactezNous')}} !</a>
                {{$t('NousNousFeronsUnPlaisirDeRépondreÀVosQuestions')}}</p>
            </div>
          </div>

        </div>


      </div>



  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++++ SCRIPT ++++++++++++++++++++++
-------------------------------------------------->
<script>
import {mapState} from 'vuex'

import planBloc from "@/components/pricing/planBloc";

export default {
  name: "faqSection",

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    // text: String, // texte à afficher dans le bouton
  },
  data: function () {
    return {
      locale: this.$i18n.locale,
      supportEmail: 'mailto:'+ process.env.VUE_APP_SUPPORT_EMAIL, // lien mailto vers le support
      faqContent: [
        {q:this.$t('pricingFaqQ0'), a:this.$t('pricingFaqR0')},
        {q:this.$t('pricingFaqQ1'), a:this.$t('pricingFaqR1')},
        {q:this.$t('pricingFaqQ2'), a:this.$t('pricingFaqR2')},
        {q:this.$t('pricingFaqQ3'), a:this.$t('pricingFaqR3')},
        {q:this.$t('pricingFaqQ4'), a:this.$t('pricingFaqR4')},
        {q:this.$t('pricingFaqQ5'), a:this.$t('pricingFaqR5')},
        {q:this.$t('pricingFaqQ6'), a:this.$t('pricingFaqR6')},
        {q:this.$t('pricingFaqQ7'), a:this.$t('pricingFaqR7')},
      ]

    }
  },

  components: {},
  computed: {
    ...mapState({
      themeToDisplay: state => state.app.themeToDisplay
    }),
  },

  methods: {},

  mounted: function () {
  }

}
</script>

<!------------------------------------------------
+++++++++++++++++++++ CSS ++++++++++++++++++++++++
-------------------------------------------------->
<style lang="scss">
// CSS NON SCOPPÉ
@import "../../assets/css/globalVar";
// Surcharge des styles de liens de la faq (car affiché depuis le texte en v-html et ne supportant pas le css scoppé ) @todo à maj car possible avec ::v-deep
.faqSection .question p a{
  color:$brandBlue;
  transition: color .3s;
  &:hover{
    text-decoration: underline;
}

}

</style>

<style scoped lang="scss">
@import "../../assets/css/globalVar";
@import "../../assets/css/bulmaResponsiveDep";

.faqSection {
  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  z-index: 10; // pour passer sous .postIt
  background-color: white;
  padding-bottom: 5rem;
  padding-top: 2rem;

  h2{
    font-size: 2rem;
    color: $brandThird;
    font-family: $mainFont2;
    font-weight: bold;
    @include touch{
      padding-top: 1.5rem;
      font-size: 1.8rem;
    }
  }
  .contTitle{
    padding: 2rem 1rem;
    //border: dashed 1px cyan;
    text-align: center;
    margin: 0 2rem 2rem;
    background-size: 80%;
    background-position: center;
    background-repeat: no-repeat;

    @include touch{
      margin: 0 1.5rem;
      padding: 3rem 1rem 1rem;
      background-size: 300%;
      background-position:  1rem top;
    }
  }
  .contQuestions{
    text-align: left;
    padding: 2rem 1rem;
    @include touch{
      padding: 2rem 1rem 1rem;
      margin-bottom: 0;
    }

    .column.a{
      @include touch{
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }

    .question {
      font-size: .9rem;
      margin-bottom: 3rem;

      h5 {
        font-weight: bold;
        font-family: $mainFont2;
        font-size: 1.1rem;
        color: $brandThird;
      }

      p {
        font-weight: bold;
        color: $brandFourth;
        line-height: 1.8rem;
      }

      .picto {
        background-color: $superLightGreen;
        $size: 2.6rem;
        border-radius: .3rem;
        margin-bottom: .5rem;
        height: $size;
        width: $size;
        display: flex;

        .icon {
          $size: 1.5rem;
          margin: auto;
          height: $size;
          width: $size;
          color: $brandPrimary;

        }

      }
    }
  }

  .invitContact{
    background-color: lighten(#e6edf2,4%);
    border: dashed 1px $lightBlue;
    padding: 2rem;
    border-radius: .5rem;
    color: $brandThird;
    display: flex;
    align-items: center;
    margin: 0 1rem;

    @include touch{
     padding: 1.5rem;
    }
    .picto{
      margin-left: 20%;
      position: relative;
      display: flex;

      @include touch{
        margin-left: 0rem;
      }

      //border: #ccc 1px dashed;
      .icon {
        color: $lightBlue;
        &.com{

          @include touch{$size: 3rem; height: $size; width: $size}
          $size: 4rem; height: $size; width: $size;
          color: lighten($lightBlue,10%);
        }
        &.smile{
          $size: 1.5rem; height: $size; width: $size;
          position: absolute;
          left: 1.2rem;
          color: $lightBlue;
          justify-self: center;
          align-self: center;
          @include touch{$size: 1rem; height: $size; width: $size; left: 1rem}

        }

      }

    }
    .txt{
      margin-left: 2rem;
      @include touch{
        margin-left: 1rem;
      }
      h6{
        font-weight: bold;
        @include touch{
          font-size: 1rem;
        }
      }
      p{
        font-size: .9rem;
        @include touch{font-size: .85rem}

        a {
          font-weight: bold; color: $brandBlue;
        }
      }
    }
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {

    background-color: $darkBg2;
    h2{
      color: $darkContrastTxt;
    }
    .question{
      h5{
        color:$darkContrastTxt
      }
      p{color:#999}
      .picto{
        background-color: $darkBg;
      }
      a{
        color: $darkBrandBlue;
      }
    }

    .invitContact{
      color: $darkContrastTxt;
      background-color: lighten($darkBg2,2%);

      .picto{
        .icon{
          color: $darkLightBlue;
        }
      }
      .txt{
        a{
          color: $darkBrandBlue;
        }
      }
    }

  }

}

</style>
